import { PlanFeatureCategory, PlanFeaturesMetadata } from '@/features/common/pricing';
import { TFunction } from 'next-i18next';
import { ReactNode } from 'react';

type CategoryFeaturesMetadata = PlanFeaturesMetadata[PlanFeatureCategory];
type FeatureMetadata = CategoryFeaturesMetadata['features'][number];

export class CategoryFeaturesMetadataBuilder {
  private features: Array<{
    name: string;
    supportByPlan: FeatureMetadata['supportByPlan'];
  }> = [];
  private _t?: TFunction;
  private _category?: PlanFeatureCategory;
  private _icon?: ReactNode;

  category(category: PlanFeatureCategory): this {
    this._category = category;
    return this;
  }

  t(t: TFunction): this {
    this._t = t;
    return this;
  }

  icon(icon: ReactNode): this {
    this._icon = icon;
    return this;
  }

  feature(name: string, supportByPlan: FeatureMetadata['supportByPlan']): this {
    this.features.push({ name, supportByPlan });
    return this;
  }

  build(): CategoryFeaturesMetadata {
    const t = this._t;
    const category = this._category;

    if (!t) throw new Error('Translation function is required to build metadata');
    if (!category) throw new Error('Category is required to build metadata');

    return {
      title: t(`features.categories.${category}`),
      icon: this._icon,
      features: this.features.map(({ name, supportByPlan }) => ({
        title: t(`features.${name}.title`),
        hint: t(`features.${name}.hint`),
        supportByPlan,
      })),
    };
  }
}
